import { gate } from 'hub-http/gates';
export const PRE_APPROVED = 'Payments:Pay040PreApprovedEnrollment';
export const KYC_EMBEDDED_FALLBACK_EXPERIENCE = gate('Payments:StripeEmbeddedOnboardingFallback');
export const PRODUCT_BUILDER = gate('commerce:product:product-builder');
export const OPTIMIZE_POST_ENROLL_M2_M3 = gate('CommerceGrowth:OptimizePostEnrollM2M3');
export const CPQ_QUOTES_GATE = gate('commerce:cpq:bse:CPQQuote');